import React from "react";
import "./../components/whychoose.css";
import { FaCheckCircle, FaShoppingBag, FaSmile } from "react-icons/fa";
// import { SiCssdesignawards } from "react-icons/si";

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="why-left">
        {/* <p className="subheading">
          <SiCssdesignawards /> LOREM IPSUM SUB HEADING
        </p> */}
        <h2>WHY CHOOSE US</h2>
        <p className="desc">
          Every single cuisine is prepared with love and care. From buttery
          naans to soft idlis, chaats and crispy samosas, we bring the true
          taste of India to your plate. It is not your normal coffee shop- it is
          a cozy and vibrant space to drink, relax and reconnect. We have got
          something to satisfy every craving.
        </p>

        <ul className="points">
          <li>
            <FaCheckCircle /> TRUE TASTE OF INDIA
          </li>
          <li>
            <FaCheckCircle /> HOT, FRESH AND FLAVORFUL
          </li>
          <li>
            <FaCheckCircle /> ONE PLACE, WIDE VARIETY
          </li>
          <li>
            <FaCheckCircle /> FAST DELIVERY- 45 MINUTES

          </li>
        </ul>

        <a href="/about-mandurah-cafe" className="why-choose-btn">
          VIEW MORE
        </a>
      </div>

      <div className="why-right">
        <div className="stats-card">
          <div className="stat-item">
            <FaShoppingBag className="icon" />
            <h3>125+</h3>
            <p>DAILY ORDER</p>
          </div>
          <hr />
          <div className="stat-item">
            <FaSmile className="icon" />
            <h3>98%</h3>
            <p>HAPPY CUSTOMERS</p>
          </div>
        </div>
        <div className="image-box">
          <img src="/Images/best-cafe-mandurah.webp" alt="Pouring Coffee" loading="lazy"/>
        </div>
        {/* <div className="why-layer">
        <img src="/Images/why-layer-1.png" alt=""></img>
      </div> */}
      </div>
    </section>
  );
};

export default WhyChooseUs;
